/**
 * 下单配置
 */
const PREFIX = 'checkmall-system'
let pagesetApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    /**获取模块列表 */
    getModuleList: '/api/module/getModuleList',
  },
}
export default pagesetApi
